export class WaterStationThreshold {
  constructor(readonly state: string, readonly color: string, readonly label: string) {}
}
